import axios from "axios";
import qs from "querystring";

interface CourserInfo {
    courseName: string;
    teacherName: string;
    courseNo: string;
    courseSeq: string;
    batchNo: string;
}

export function queryCourseByInvitationCode(batchNo: string, code: string) {
    return axios
        .get<SuccessData<CourserInfo>>("/student/queryCourseByInvitationCode", {
            params: { batchNo, code }
        })
        .then(res => res.data.data);
}

export function studentSaveCourse(
    batchNo: string,
    courseNo: string,
    courseSeq: string,
    courseId: string
) {
    return axios.post<SuccessData<any>>(
        "/student/studentSaveCourse",
        qs.stringify({ batchNo, courseNo, courseSeq, courseId })
    );
}

/**
 * 通过邀请码查询课程
 */
export function getCourseInfoByJoinInCode(joinInCode: string) {
    return axios
        .post<SuccessData<CourserInfo>>(
            "/student/getCourseInfoByJoinInCode",
            qs.stringify({ joinInCode })
        )
        .then(res => res.data.data);
}

/**
 * 输入邀请码加入课程
 */
export function stuCourseJoinInByCode(joinInCode: string) {
    const params = joinInCode.trim();
    return axios.post(
        "/student/stuCourseJoinInByCode",
        qs.stringify({ joinInCode: params })
    );
}
